import LocalizedStrings from "react-localization";

export const LOCALE = new LocalizedStrings({
  mk: {
    "this vacancy is not allowed for entered school":
      "Овој конкурс не е достапен за вашето училиште",
    TURKISH: "Турски",
    ALBANIAN: "Албански",
    MACEDONIAN: "Македонски",
    submit_app: "Поднеси апликација",
    max_points: "Максимален број на поени",
    min_points_for_commision_eval:
      "Минимален број на поени за услов за доставување на барање до БРО/ЦСОО и Училиште",
    min_points_for_ranklist: " Минимален број на поени за услов за Ранг Листа",
    total: "Вкупно",
    total_left: "Преостанати",
    successfuly_changed_password: "Успешно променета лозинка",
    succesfuly_send_password_reset_mail:
      "Доколку е-маил адресата е валидна на истата ке биде пратен линк за ресетирање на лозинката",
    verifying_email: "Потврдување на е-пошта",
    email_verified: "E-поштата е потврдена",
    upload_file_piom: "ПРИКАЧИ ДОКУМЕНТ ОД ПИОМ",
    years_working_experience: "Години работно искуство",
    teaching_languages: "Наставен јазик",
    macedonian: "Македонски",
    albanian: "Албански",
    turkish: "Турски",
    professional_subjects: "Стручни Предмети",
    basic_subjects: "Општи Предмети",
    subjects_type: "Тип на предмети",
    TEACHER_MENTOR: "Наставник-Ментор",
    TEACHER_ADVISOR: "Наставник-Советник",
    ASSOCIATE_MENTOR: "Стручен соработник-Ментор",
    ASSOCIATE_ADVISOR: "Стручен соработник-Советник",
    rank_list: "Ранг листа",
    rank_lists: "Ранг листи",
    view_rank_lists: "Преглед на ранг листи",
    update_rank_list_data: "Ажурирај податоци",
    professional_development_grading: "Оценување професионален развој",
    generate_rank_list: "Генерирај ранг листа",
    pending_apps_for_eval: "Преостанати апликации за оценување",
    choose_vacancy: "Избери конкурс",
    submitted_apps: "Поднесени апликации",
    no_data_for_analyse: "Нема податоци за анализа.",
    apps_status: "Статус на апликации",
    all: "Сите",
    professional_practice_grading: "Оценување професионална практика",
    commission_grading: "Оценување од комисија",
    number: "Бр.",
    name_and_surname_applicant: "Име и презиме на кандидатот",
    points_from_bureau: "Бодови од оценка на биро за развој на образованието",
    points_from_educational_center: "Бодови од мислењето на училиштето",
    point_from_professional_development: "Бодови од професионален развој",
    total_points: "Вкупно бодови",
    rank_list_candidates_fulfilled_conditions:
      "Ранг листa на кандидати кои ги исполниле сите услови",
    confirm_points: "Потврди поени",
    change_points: "Промени поени",
    comment: "Коментар",
    dashboard: "Работна табла",
    charts: "Извештаи",
    test: "Тест",
    settings: "Подесувања",
    inbox: "Пораки",
    messages: "Пораки",
    starred: "Важни",
    profile: "Профил",
    my_profile: "Мој профил",
    notifications: "Известувања",
    language: "Јазик",
    next: "Следно",
    previous: "Претходно",
    back: "Назад",

    users: "Корисници",
    groups: "Групи",
    privileges: "Привилегии",
    role: "Улога",

    details: "Детали",
    edit: "Промени",
    delete: "Избриши",
    close: "Затвори",
    save: "Зачувај",
    yes: "Да",
    cancel: "Откажи",
    add: "Додади",
    key: "Клуч",
    value: "Вредност",

    id: "ID",
    username: "Корисничко име",
    name: "Име",
    firstName: "Име",
    lastName: "Презиме",
    fullName: "Име и презиме на подносител",
    email: "Е-пошта",
    date_created: "Датум на креирање",
    actions: "Акции",
    rows_per_page: "Редови по страница",
    remove: "Отстрани",
    created_by: "Kреирано од",
    created_at: "Креирано на",
    modified_by: "Променето од",
    modified_at: "Променето на",
    filter_by: "Филтер по",
    not_modified: "Непроменето",
    password: "Лозинка",

    user_details: "Детали за корисникот",
    user_edit: "Промена за корисникот",
    entity_delete_confirmation_text: "Дали сте сигурни",
    user_delete: "Бришење на корисник",
    create_new_user: "Креирај нов корисник",
    user_update_success_message: "Корисникот е успешно ажуриран",
    user_deleted_success_message: "Корисникот е успешно избришан",
    user_create_success_message: "Корисникот е успешно креиран",

    user_profile: "Кориснички профил",
    user_profile_general: "Општи податоци",
    user_profile_change_password: "Промени лозинка",
    new_password: "Нова лозинка",
    repeat_password: "Повтори лозинка",

    group_details: "Детали за групата",
    group_delete: "Бришење на група",
    members: "Членови",
    add_new_members: "Додади нови членови",
    create_new_group: "Креирај нова група",
    member_added_success_message: "Членот е успешно додаден",
    member_removed_success_message: "Членот е успешно отстранет",
    group_updated_success_message: "Групата е успешно ажурирана",
    group_created_success_message: "Гроупата е успешно креирана",
    group_deleted_success_message: "Групата е успешно избришана",

    all_privileges: "Сите привилегии",
    add_groups_to_privilege: "Додади групи на привилегија",
    current_privilege_groups: "Групи на привилегија",
    group_added_success_message: "Групата е успешно додадена",
    group_removed_success_message: "Групата е успешно отстранета",

    system_settings_props_updated_success: "Подесувањата се успешно ажурирани",
    mail_sent_success_message: "Пораката е успешно испратена",
    success: "Успешно",
    test_failure: "Неуспешно",
    reason: "Причина",
    test_mail_server_header: "Тестирање на е-меил серверот",
    test_mail_server_subheader:
      "Во овој дел можете да го тестирате е-меил серверот",
    test_mail_server_description:
      "Моментално се подесени следните SMTP параметри",
    send_test_mail: "Испрати",
    email_address: "Е-меил адреса",
    user_your_own_email_address: "Користи ја само својата е-меил адреса",
    for_testing_purposes_only:
      "Ова функционалност треба да се користи исклучиво за тестирање на е-меил (SMTP) серверот",
    mail_test_results_info_message:
      "Овде ќе го видите резултатот после тестирањето",
    mail_test_results_info_header: "Резултати од тестот",
    props: "Параметри",

    audit_log: "Аудит лог",
    users_audit_log: "Корисници",
    groups_audit_log: "Групи",
    system_settings_audit_log: "Системски подесувања",
    audit_details: "Детали за лог запис",
    revtype: "Тип на акција",
    revtstmp: "Време на акција",
    propKey: "Име на поставката",
    propVal: "Вредност на поставката",

    mail_log: "Лог на е-пошта",
    mail_all: "Сите",
    mail_success: "Успешни",
    mail_pending: "На чекање",
    mail_processing: "Процесирање",
    mail_failed: "Неуспешни",
    mail_canceled: "Откажани",
    mail_sender: "Испраќач",
    mail_receiver: "Примач",
    mail_createdAt: "Креирана на",
    mail_sentAt: "Испратена на",
    mail_status: "Статус",
    mail_details: "Детали",
    mail_requeued: "Препратени",
    mail_requeue: "Препрати",
    mail_content: "Содржина",
    mail_view_mail_content: "Содржина на е-меил пораката",
    mail_error_log: "Детали за грешката",
    mail_error_details: "Детали за грешка при испраќање",
    mail_subject: "Наслов/Предмет",
    mail_mail_details: "Детали за меил пораката",
    mail_template: "Урнеци за е-пошта",
    MAIL_TEMPLATE_REGISTRATION: "Успешна Регистрација",
    MAIL_TEMPLATE_FORGOT_PASSWORD: "Заборавена Лозинка",
    MAIL_TEMPLATE_ADDITIONAL_DATA_REQUIRED: "Дополнување на апликација",
    mail_template_save_success: "Успешно зачуван урнек",
    mail_template_save_failure: "Грешка при зачувување на урнек",
    mail_template_available_params: "Достапни параметри",
    mail_send_test_mail: "Прати тест е-пошта",

    administration: "Администраторски панел",
    field_1_required: "Поле 1 е задолжително",
    filed_2_must_be_number: "Поле 2 мора да биде целобројна вредност",
    filed_3_is_not_valid_national_id_code: "Поле 3 не е валиден ЕМБГ",

    login_h1: "Министерство за образование и наука",
    login_h2: "Систем за кариерно напредување",
    login_signin: "Најави се",
    login_signup: "Регистрирај се",
    login_signup_link: "Немаш корисничка сметка?",
    login_forgot_password: "Промени лозинка",
    login_forgot_password_link: "Заборавена лозинка?",
    login_email: "Е-пошта",
    login_firstname: "Име",
    login_lastname: "Презиме",
    login_username: "Корисничко име",
    login_password: "Лозинка",
    login_confirm_password: "Потврди лозинка",
    login_submit: "Потврди",
    login_createuser_success: "Успешно регистриран корисник: ",

    required_field: " е задолжително поле",
    wrong_format: " е во погрешен формат",
    password_doesnt_match: "Лозинките не се совпаѓаат",

    logout: "Oдјави се",
    forbidden_h1: "Забрането ви е да ja пристапите оваа страница.",
    forbidden_h2: "Пренасочување кон почетната страница за ",

    formbuilder: "Form Builder",
    configuration: "Конфигурација",
    municipality: "Општина",
    municipalities: "Општини",
    municipalities_create_new_municipality: "Креирај нова општина",
    municipalities_municipality_name: "Име",
    municipalities_municipality_name_en: "Име Англиски",
    municipalities_municipality_name_al: "Име Албански",
    municipalities_municipality_code: "Код",
    municipalities_municipality_active: "Активна",
    municipalities_create_success_message: "Општината е успешно креирана",
    municipalities_update_success_message: "Општината е успешно ажуриранa",
    municipalities_deleted_success_message: "Општината е успешно избришана",
    municipalities_details: "Детали за општината",
    municipalities_delete: "Бришење на општина",

    formbuilder_new_form: "Креирај нова форма",
    school: "Училиште",
    schools: "Училишта",
    schools_create_new_school: "Креирај ново училиште",
    schools_school_name: "Име",
    schools_school_email: "Е-пошта",
    school_municipality: "Општина",
    schools_create_success_message: "Училиштето е успешно креирано",
    schools_update_success_message: "Училиштето е успешно ажурирано",
    schools_deleted_success_message: "Училиштето е успешно избришано",
    schools_create_new_school: "Креирај ново училиште",
    schools_details: "Детали за училиште",
    schools_edit: "Промени податоци за училиштето",
    schools_delete: "Избриши училиште",

    vacancies: "Конкурси",
    new_vacancy_application: "Нова апликација на конкурс",
    vacancy: "Конкурс",
    create_new_vacancy: "Креирај нов конкурс",
    vacancy_details: "Детали за конкурсот",
    edit_vacancy: "Промени податоци за конкурс",
    delete_vacancy: "Избриши конкурс",
    vacancy_create_success_message: "Конкурсот е успешно креиран",
    vacancy_update_success_message: "Конкурсот е успешно ажуриран",
    vacancy_deleted_success_message: "Конкурсот е успешно избришан",

    teacher: "Наставник",
    associate: "Стручен соработник",
    commission: "Комисија",
    advisor: "Советник",
    commission_name: "Име на комисија",
    administrator: "Администратор",

    training: "ОБУКИ",
    professional_event: "НАУЧНО-СТРУЧНИ КОНФЕРЕНЦИИ,КОНГРЕСИ,СИМПОЗИУМИ",
    authorship: "АВТОРСТВО",
    educational_activity:
      " УЧЕСТВО ВО АКТИВНОСТИ ЗА ПОДОБРУВАЊЕ НА ВОСПИТНО-ОБРАЗОВНАТА РАБОТА",
    awards_and_recognition: "НАГРАДИ И ПРИЗНАНИЈА",
    professional_title: "НАУЧНО/ СТРУЧНО ЗВАЊЕ",
    configuration_area: "Конфигурација на области",

    training_organizer: "Организатор на обука",
    create_new_training_organizer: "Креирај нов организатор",
    training_organizer_details: "Детали за организатор",
    edit_training_organizer: "Промени организатор",
    delete_training_organizer: "Избриши организатор",
    training_organizer_create_success_message:
      "Организаторот е успешно креиран",
    training_organizer_update_success_message:
      "Организаторот е успешно ажуриран",
    training_organizer_deleted_success_message:
      "Организаторот е успешно избришан",

    training_role: "Улога на кандидатот",
    create_new_training_role: "Креирај нова улога",
    training_role_details: "Детали за улога",
    edit_training_role: "Промени улога",
    delete_training_role: "Избриши улога",
    training_role_create_success_message: "Улогата е успешно креирана",
    training_role_update_success_message: "Улогата е успешно ажурирана",
    training_role_deleted_success_message: "Улогата е успешно избришана",

    training_hour_range: "Времетраење",
    create_new_training_hour_range: "Креирај нов ранг на часови",
    training_hour_range_details: "Детали за ранг на часови",
    edit_training_hour_range: "Промени ранг на часови",
    delete_training_hour_range: "Избриши ранг на часови",
    training_hour_range_create_success_message:
      "Ранг на часови е успешно креиран",
    training_hour_range_update_success_message:
      "Ранг на часови е успешно ажуриран",
    training_hour_range_deleted_success_message:
      "Ранг на часови е успешно избришан",

    event: "Настан",
    create_new_event: "Креирај нов настан",
    event_details: "Детали за настан",
    edit_event: "Промени настан",
    delete_event: "Избриши настан",
    event_create_success_message: "Настанот е успешно креиран",
    event_update_success_message: "Настанот е успешно ажуриран",
    event_deleted_success_message: "Настанот е успешно избришан",

    authorship_type: "Вид на авторство",
    create_new_authorship_type: "Креирај нов вид",
    authorship_type_details: "Детали за вид на авторство",
    authorship_type_edit: "Промени вид на авторство",
    authorship_type_delete: "Избриши вид на авторство",
    authorship_type_create_success_message:
      "Успешно е креиран нов вид на авторство",
    authorship_type_update_success_message: "Успешно е ажурирано",
    authorship_type_deleted_success_message: "Успешно е избришан",

    educational_activity_type: "Вид на активност",
    create_new_educational_activity_type: "Креирај нов вид на активност",
    educational_activity_details: "Детали за вид на активност",
    educational_activity_type_edit: "Промени вид на активност",
    educational_activity_type_delete: "Избриши вид на активност",
    educational_activity_type_create_success_message:
      "Успешно е креиран нов вид на активност",
    educational_activity_type_update_success_message: "Успешно е ажурирано",
    educational_activity_type_deleted_success_message: "Успешно е избришан",

    award_recognition: "Носител на награда",
    create_new_award_recognition: "Креирај нов носител на награда",
    award_recognition_details: "Детали за носител на награда",
    award_recognition_edit: "Промени носител на награда",
    award_recognition_delete: "Избриши носител на награда",
    award_recognition_create_success_message:
      "Успешно е креиран нов носител на награда",
    award_recognition_update_success_message: "Успешно е ажуриран носителот",
    award_recognition_deleted_success_message: "Успешно е избришан носителот",

    award_level: "Ниво на награда",
    create_new_award_level: "Креирај ново ниво",
    award_level_details: "Детали за ниво на награда",
    award_level_edit: "Промени ниво на награда",
    award_level_delete: "Избриши ниво на награда",
    award_level_create_success_message:
      "Успешно е креиран ново ниво на награда",
    award_level_update_success_message: "Успешно е ажурирано нивото",
    award_level_deleted_success_message: "Успешно е избришано нивото",

    award_type: "Вид на награда",
    create_new_award_type: "Креирај нов вид на награда",
    award_type_details: "Детали за вид на награда",
    award_type_edit: "Промени вид на награда",
    award_type_delete: "Избриши вид на награда",
    award_type_create_success_message: "Успешно е креиран нов вид на награда",
    award_type_update_success_message: "Успешно е ажурирано",
    award_type_deleted_success_message: "Успешно е избришан",

    professional_title_type: "Звање/научен степен",
    create_new_professional_title_type: "Креирај ново Звање/научен степен",
    professional_title_type_details: "Детали за Звање/научен степен",
    professional_title_type_edit: "Промени Звање/научен степен",
    professional_title_type_delete: "Избриши Звање/научен степен",
    professional_title_type_create_success_message:
      "Успешно е креиран ново Звање/научен степен",
    professional_title_type_update_success_message: "Успешно е ажурирано",
    professional_title_type_deleted_success_message: "Успешно е избришан",

    professional_title_area: "Област",
    create_new_professional_title_area: "Креирај нова област",
    professional_title_area_details: "Детали за област",
    professional_title_area_edit: "Промени област",
    professional_title_area_delete: "Избриши област",
    professional_title_area_create_success_message:
      "Успешно е креиран нова област",
    professional_title_area_update_success_message: "Успешно е ажурирано",
    professional_title_area_deleted_success_message: "Успешно е избришан",

    schema_points: "Шема за бодови",
    active: "Активна",
    points: "Бодови",
    defaultPoints: "Основни поени",
    maxPoints: "Максимални поени",
    schema_points_update_success_message:
      "Успешно е ажуриранa шемата со бодови",

    invalid_email_address_format: "Форматот на меил адресата е невалиден",
    phoneNumber: "Телефонски број",

    organizer: "Организатор",
    hourRange: "Времетраење во часови",
    type: "Тип",
    place: "Место",
    duration: "Времетраење",
    carrier: "Носител",
    awardType: "Тип на награда",
    awardLevel: "Ниво на награда",
    eventType: "Вид на настан",
    year: "Година",
    laborName: "Наслов на трудот",
    publicationName: "Наслов на публикација",
    proof: "Доказ",
    title: "Наслов",
    description: "Опис",

    basic_info: "Податоци за подносителот",
    professional_development: "Професионален развој",
    professional_practice: "Професионална пракса",
    preview_and_submit: "Преглед и поднесување",

    open_vacancies: "Отворени конкурси",
    my_applications: "Мои апликации",
    view_applications: "Преглед на апликации",
    view_applications_for_distribution: "Преглед на апликации за распределба",
    start_distribution: "Започни распределба",
    managing_applications_additional_info:
      "Менаџирање на апликации кои се вратени на доработка",
    view_graded_applications: "Преглед на оценети апликации",
    submissionDate: "Датум на поднесување",
    status: "Статус",
    open: "Отвори",
    startDate: "Датум на почеток",
    endDate: "Датум на крај",
    create_new_vacancy: "Креирај нов конкурс",
    vacancy_evaluation: "Оценување на конкурс апликација",

    grading_schema: "Шема за оценување",
    grading_schema_basic_info: "Основни податоци за шема",
    grading_schema_config: "Конфигурација на шема",
    grading_schema_create_new: "Креирај нова шема",
    grading_schema_name: "Име на шема",
    grading_schema_locked: "Заклучена",
    grading_schema_details: "Детали за шема на оценување",
    grading_schema_edit: "Промени шема на оценување",
    grading_schema_delete: "Избриши шема на оценување",
    grading_schema_create_success_message: "Успешно е креирана нова шема",
    grading_schema_update_success_message: "Успешно е ажурирана шемата",
    grading_schema_deleted_success_message: "Успешно е избришана шемата",

    bureau_grading_dashboard: "Оценување од БРО",
    bureau_grading: "Оценување од БРО",

    educational_center_grading_dashboard: "Оценување од ЦСОО",
    educational_center_grading: "Оценување од ЦСОО",

    school_grading_dashboard: "Оценување од училиштето",
    school_grading: "Оценување од училиштето",

    grade: "Оцени",
    all_applications: "Сите апликации",
    grading: "Оценување",

    must_be_number: " мора да биде број",
    must_be_positive: " мора да биде позитивен број",
    required_at_least_one_attachment:
      "Барем еден документ треба да биде прикачен",

    action_timestamp: "Време на акцијата",
    schools_municipality: "Општина на училиште",
    no_data_for_analysis: "Нема податоци за обработка",
    application_submited_sucessfully: "Успешно поднесена апликација",
    total_points_by_domain: "Вкупно бодови по област",
    transfer_item_for_additional_data: "Врати на дополнување",
    expires_in: "Истекува за",
    expires_at: "Истекува на",
    days: "денови",
    day: "ден",
    application_time_expired: "Времето за аплицирање е истечено",
    apply: "Аплицирај",
    vacancy_released_at: "Конкурсот е објавен на:",
    vanacy_ends_at: "Конкурсот завршува на:",
    list_of_proofs_for_professional_development:
      "Листа на докази за професионален развој",
    domain: "област",
    trainings: "Обуки",
    professional_events: "Научно-стручни настани, конференции, симпозиуми",
    educational_activities:
      "Учество во активности за подобрување на воспитно-образовната работа",
    awards_and_recognitions: "Награди и признанија",
    professional_title: "Научно/стручно звање",
    authorships: "Авторства",
    basic_info_description:
      "Во овој дел на апликацијата, треба да ги пополните полињната со вашите податоци за да преминете на следниот чекор.",
    choose_type_of_subjects:
      "Изберете го типот на вашите предмети: Општи или стручни",
    choose_type_of_subjects_description:
      "Доколку предавате по предмети кои се општи, во подлното опаѓачко мени изберете ја опцијата 'Општи предмети'. Доколку предавате по стручни предмети изберете ја опцијата 'Стручни предмети' соодветно.",
    training_info_title: "Обуки",
    training_info_description:
      "Во овој дел од апликацијата внесете ги обуките на кои што се присуствувале, улогата која што се ја имале на тие обуки, како и времетраењето во часови. Во полето 'доказ' мора да прикачите еден или повеќе документи.",
    professional_event_info_title:
      "Научно-стручни настани, конференции, конгреси, симпозиуми",
    professional_event_info_description:
      "Тука треба да внесете податоци за Научно-стручни настани во кои сте зеле учество, улогата која сте ја имале на тој стручен настан како и видот на стручниот настан. Во полето 'доказ' мора да прикачите еден или повеќе документи.",
    educational_acvitity_info_title:
      "Учество во активности за подобрување на воспитно-образовната работа",
    educational_acvitity_info_description:
      "Тука треба да внесете податоци за вашите учества во активности за подобрување на воспитно-образовната работа (Меѓународни мерења на постигнувања, национални тестови, наставни програми, иновативни проекти, стратешки документи, истражувачки проекти итн.). Во полето 'доказ' мора да прикачите еден или повеќе документи. ",
    awards_and_recognitions_info_title: "Награди и признанија",
    awards_and_recognitions_info_description:
      "Во овој дел треба да внесете податоци и да прикачите документи како докази за награди и признанија кои сте ги добиле како наставник или ментор на ученик, како и нивото на натпреварот (Општинско, државно, меѓународно). Во полето 'доказ' мора да прикачите еден или повеќе документи.",
    authorships_info_title: "Авторство",
    authorships_info_description:
      "Во овој дел треба да внесете податоци и да прикачите документи како докази за ваши авторства на учебници, прирачници, објава во научно-стручно списание, научни-стручни материјали и трудови, списание со импакт фактор итн. Во полето 'доказ' мора да прикачите еден или повеќе документи.",

    num: "Реден број",
    training_name: "Назив на обуката",

    professional_event_name: "Назив на стручниот настан",
    professional_event_type: "Вид на стручниот настан",
    professional_event_role: "Улога",
    professional_event_date: "Датум на одржување",
    professional_event_place: "Место на одржување",

    no_trainings_added: "Немате додадени обуки",
    add_training: "Додади обука",

    no_professional_event_added: "Немате додадени стручни настани",
    add_professional_event: "Додади стручен настан",

    educational_activity_name: "Назив на активноста",
    educational_activity_role: "Улога",
    educational_activity_type: "Вид на активност",
    educational_activity_duration: "Времетраење",
    educational_activity_year: "Година на реализација",

    no_activities_added: "Немате додадени активности",
    add_activity: "Додади активност",

    award_name: "Име на наградата",
    award_carrier: "Носител",

    no_awards_or_recognitions_added: "Немате додадени награди/признанија",
    add_awards_or_recognitions: "Додади награда/признание",

    professional_title_info_title: "Научно/Стручно звање",
    professional_title_info_description:
      "Тука треба да внесете податоци и да прикачите доказ за вашето научно/стручно звање.",
    no_professional_titles_added: "Немате додадени научни/стручни звања",
    add_professional_title: "Додади звање",

    no_authorships_added: "Немате додадени авторства",
    add_authorship: "Додади авторство",
    authorship_title: "Наслов на трудот",
    authorship_publication_type: "Вид на публикација",
    authorship_publication_title: "Наслов на публикација",
    authorship_role: "Улога",
    authorship_release_year: "Година на издавање",

    date: "Датум",

    DRAFT: "НАЦРТ",
    SUBMITTED: "ПОДНЕСЕНО",
    ADDITIONAL_DATA_REQUIRED: "ВРАТЕНО ЗА ДОПОЛНУВАЊЕ",
    COMMISION_EVAL: "ЕВАЛУАЦИЈА ОД КОМИСИЈА",
    BRO_CSO_SCHOOL_EVAL: "ЕВАЛУАЦИЈА ОД БРО/ЦСОО/УЧИЛИШТЕ",
    EVALUATED: "ОЦЕНЕТО",
    REJECTED: "ОДБИЕНО",
    PENDING: "ЗА ОБРАБОТКА",
    PROCESSING: "ВО ПРОЦЕС НА ОБРАБОТКА",
    DONE: "ЗАВРШЕНО",
    FAILED: "НЕУСПЕШНО",
    CANCELED: "ОТКАЖАНО",
    SUCCESS: "УСПЕШНО",
    SUSPENDED: "ЗАПРЕНА ПОСТАПКА",
    dropzoneText: "Повлечете ја датотеката тука",
    fileType: "Тип на документ",
    fileName: "Име на документ",
    fileSize: "Големина на документ",

    comment_info_box_text:
      "Доколку имате забелешка/коментар околу доказите на корисникот внесете го во полето подолу.",
    additional_data_info_box_title: "Дополнување",
    additional_data_info_box_text:
      "Апликацијата ке биде вратена кај корисникот на дополнување, доколку имате некаков коментар за корисникот внесете го во полето подолу.",
    apps_for_commission_evaluation: "Апликации за оценување од комисија",
    no_apps_for_evaluating: "Нема апликации за обработка",
    apps_for_bureau_evaluation: "Апликации за оценување од БРО",
    apps_for_educenter_evaluation: "Апликации за оценување од ЦСОО",
    apps_for_school_evaluation: "Апликации за оценување од yчилиште",
    educationalCenterGradingStatus: "Статус",
    submit_evaluation: "Заврши оценување",
    attach_file: "Прикачи документ",
    no_documents_attached: "Немате прикачено документи",

    educenter_grading_info_box_title: "Оценување",
    educenter_grading_info_box_description:
      "Во овој дел треба да дадете оцена од страна на Бирото за развој на образование. Внесете поени и прикачете документ.",

    bureau_grading_info_box_title: "Оценување",
    bureau_grading_info_box_description:
      "Во овој дел треба да дадете оцена од страна на Бирото за развој на образование. Внесете поени и прикачете документ.",

    school_grading_info_box_title: "Оценување",
    school_grading_info_box_description:
      "Во овој дел треба да дадете оцена од страна на училиштето. Внесете поени и прикачете документ.",

    invalid_data_entry: "Невалиден внес на податоци",
    uploadFile: "Прикачи документ",
    evaluation_submited: "Оценувањето е завршено",

    owned_by: "Тип на училиште",
    school_type: "Степен на училиште",
    country_school: "Државно",
    municipality_school: "Општинско",
    elementary_school: "Основно училиште",
    middle_school: "Средно училиште",

    dateOfBirth: "Датум на раѓање",
    commission_eval: "Оценување на комисија",
    bureau_eval: "Оценување на БРО",
    eduCenter_eval: "Оценување на ЦСОО",
    school_eval: "Оценување на училиште",

    distribution_by_commission: "Распределба по комисии",
    transfer_applications: "Префрлање на апликации",
    finishing_applications: "Апликации на доработка",

    distribution_applications_by_commission:
      "Распределба на поднесени апликации по комисии",
    transfer_applications_between_commissions:
      "Префрлање на поднесени апликации помеѓу комисии",
    applications_to_be_finished: "Апликации вратени на доработка",
  },
  al: {
    "this vacancy is not allowed for entered school":
      "Ky konkurs nuk është i disponueshëm për shkollën tuaj",
    ALBANIAN: "Shqiptare",
    MACEDONIAN: "Maqedonas",
    submit_app: "Dorëzoni një aplikim",
    max_points: "Numri maksimal i pikëve",
    min_points_for_commision_eval:
      "Numri minimal i pikëve për kusht për dorëzimin e kërkesës në BZHA/QAPT dhe Shkollë",
    min_points_for_ranklist: "Numri minimal i pikëve për kusht për rang-listë",
    total: "Gjithsej",
    total_left: "Mbetur",
    successfuly_changed_password: "Fjalëkalimi me sukes u ndryshua",
    succesfuly_send_password_reset_mail:
      "Përderisa e-mail adresa është valide për të njëjtën do të dërgohet link për rivendosjen e fjalëkalimit",
    verifying_email: "Konfirmimi i e - postës",
    email_verified: "E - posta është konfrimuar",
    upload_file_piom: "NGJIT DOKUMENTIN NGA FSPI",
    years_working_experience: "Vite përvojë pune",
    teaching_languages: "Gjuha mësimore",
    macedonian: "Maqedonisht",
    albanian: "Shqip",
    turkish: "Turqisht",
    professional_subjects: "Lëndë profesionale",
    basic_subjects: "Lëndë të përgjithshme",
    subjects_type: "Lloji i lëndëve",
    TEACHER_MENTOR: "Mësimdhënës-Mentor",
    TEACHER_ADVISOR: "Mësimdhënës-Këshilltar",
    ASSOCIATE_MENTOR: "Bashkëpunëtor profesional-Mentor",
    ASSOCIATE_ADVISOR: "Bashkëpunëtor profesional-Këshilltar",
    rank_list: "Rang-listë",
    rank_lists: "Listat e renditjes",
    view_rank_lists: "Shikoni renditjen",
    update_rank_list_data: "Përditëso të dhënat",
    professional_development_grading: "Zhvillimi profesional dhe vlerësimi",
    generate_rank_list: "Gjeneroni rangë-listë",
    pending_apps_for_eval: "Aplikimet e mbetura për vlerësim",
    choose_vacancy: "Zgjidh konkursin",
    submitted_apps: "Aplikimet e parashtruara",
    no_data_for_analyse: "Nuk ka të dhëna për analizë",
    apps_status: "Statusi i aplikimeve",
    all: "Të gjithë",
    professional_practice_grading: "Praktika profesionale dhe vlerësimi",
    commission_grading: "Vlerësimi nga komisoni",
    number: "Nu.",
    name_and_surname_applicant: "Emri dhe mbiemri i kandidatit",
    points_from_bureau: "Rezultatet nga byroja e zhvillimit të arsimit",
    points_from_educational_center: "Pika nga opinioni i shkollës",
    point_from_professional_development: "Pikat e zhvillimit profesional",
    total_points: "Gjithsej pikë",
    rank_list_candidates_fulfilled_conditions:
      "Renditja e kandidatëve që i kanë plotësuar të gjitha kushtet",
    confirm_points: "Vërteto pikët",
    change_points: "Ndrysho pikët",
    comment: "Koment",
    dashboard: "Tebelë pune",
    charts: "Raportet",
    test: "Test",
    settings: "Cilësimet",
    inbox: "Porosi",
    messages: "Porosi",
    starred: "Të rëndësishme",
    profile: "Profili",
    my_profile: "Profili im",
    notifications: "Njoftimet",
    language: "Gjuha",
    next: "Tjetër",
    previous: "Më parë",
    back: "Prapa",
    users: "Shfrytëzues",
    groups: "Grupe",
    privileges: "Privilegje",
    role: "Roli",
    details: "Detaje",
    edit: "Ndyshime",
    delete: "Fshij",
    close: "Mbyll",
    save: "Ruaj",
    yes: "Po",
    cancel: "Anulo",
    add: "Shto",
    key: "Çelës",
    value: "Vlerë",
    id: "ID",
    username: "Emri i shfrytëzuesit",
    name: "Emri",
    firstName: "Emri",
    lastName: "Mbiemri",
    fullName: "Emri dhe mbiemri i aplikantit",
    email: "E-postë",
    date_created: "Data e krijimit",
    actions: "Veprimet",
    rows_per_page: "Reshtat sipas faqes",
    remove: "Largoni",
    created_by: "E krijuar nga",
    created_at: "E krijuar më",
    modified_by: "E ndryshuar nga",
    modified_at: "E ndryshuar më",
    filter_by: "Filtri sipas",
    not_modified: "E pandryshuar",
    password: "Fjalëkalimi",
    user_details: "Detaje për shfrytëzuesin",
    user_edit: "Ndryshimi për shfrytëzuesin",
    entity_delete_confirmation_text: "A jeni të sigurtë",
    user_delete: "Fshirja e shfrytëzuesit",
    create_new_user: "Krijo shfrytëzues të ri",
    user_update_success_message: "Shfrytëzuesi me sukses është azhurnuar",
    user_deleted_success_message: "Shfrytëzuesi me sukses është fshirë",
    user_create_success_message: "Shfrytëzuesi me sukses është krijuar",
    user_profile: "Priofili i shfrytëzuesit",
    user_profile_general: "Të dhëna të përgjithshme",
    user_profile_change_password: "Ndrysho fjalëkalimin",
    new_password: "Fjalëkalimi i ri",
    repeat_password: "Përsërit fjalëkalimin",
    group_details: "Detaje për grupin",
    group_delete: "Fshirja e grupit",
    members: "Anëtarë",
    add_new_members: "Shto anëtarë të rinj",
    create_new_group: "Krijo grup të re",
    member_added_success_message: "Anëtari me sukses është shtuar",
    member_removed_success_message: "Anëtari me sukses është larguar",
    group_updated_success_message: "Grupi me sukses është azhurnuar",
    group_created_success_message: "Grupi me sukses është krijuar",
    group_deleted_success_message: "Grupi me sukses është fshirë",
    all_privileges: "Të gjitha privilegjet",
    add_groups_to_privilege: "Shto grupe të privilegjit",
    current_privilege_groups: "Grupe të privilegjit",
    group_added_success_message: "Grupi me sukses është shtuar",
    group_removed_success_message: "Grupi me sukses është larguar",
    system_settings_props_updated_success: "Cilësimet me sukses janë azhurnuar",
    mail_sent_success_message: "Porosia me sukses është dërguar",
    success: "Me sukses",
    test_failure: "Pa sukses",
    reason: "Arsyeja",
    test_mail_server_header: "Testimi i serverit të e-mailit",
    test_mail_server_subheader:
      "Në këtë pjesë mund ta testoni serverin e e-mailit",
    test_mail_server_description:
      "Aktualisht janë parashtruar parametrat SMTP në vijim",
    send_test_mail: "Dërgo",
    email_address: "E-mail adresa",
    user_your_own_email_address: "Shfrytëzo vetëm e-mail adresën tënde",
    for_testing_purposes_only:
      "Ky funksionalitet duhet të shfrytëzohet në përjashtim për testimin e serverit (SMTP) të e-mailit",
    mail_test_results_info_message:
      "Këtu do ta shikoni rezultatin pas testimit",
    mail_test_results_info_header: "Rezultati nga testimi",
    props: "Parametrat",
    audit_log: "Regjistri i auditimit",
    users_audit_log: "Shfrytëzuesit",
    groups_audit_log: "Grupet",
    system_settings_audit_log: "Cilësimet e sistemit",
    audit_details: "Detajet e auditimit të incizimit",
    revtype: "Lloji i veprimit",
    revtstmp: "Koha e veprimit",
    propKey: "Emri i pohimit",
    propVal: "Vlera e pohimit",
    mail_log: "Regjistri i e-postës",
    mail_all: "Të gjitha",
    mail_success: "Me sukses",
    mail_pending: "Në pritje",
    mail_processing: "Përpunimi",
    mail_failed: "Pa sukses",
    mail_canceled: "Të anuluara",
    mail_sender: "Dërguesi",
    mail_receiver: "Pranuesi",
    mail_createdAt: "Krijuar më",
    mail_sentAt: "Dërguar më",
    mail_status: "Statusi",
    mail_details: "Detaje",
    mail_requeued: "Të dërguara",
    mail_requeue: "Dërgo",
    mail_content: "Përmbajtja",
    mail_view_mail_content: "Përmbajtja e porosisë së e-mailit",
    mail_error_log: "Detaje për gabimin",
    mail_error_details: "Detaje për gabim gjatë dërgimit",
    mail_subject: "Titulli/Lënda",
    mail_mail_details: "Detaje për porosinë e e-mailit",
    mail_template: "Modele për e-postë",
    MAIL_TEMPLATE_REGISTRATION: "Regjistrim i suksesshëm",
    MAIL_TEMPLATE_FORGOT_PASSWORD: "Fjalëkalimi i harruar",
    mail_template_save_success: "Modeli i ruajtur me sukses",
    mail_template_save_failure: "Gabim gjatë ruajtjes së modelit",
    mail_template_available_params: "Parametrat në dispozicion",
    mail_send_test_mail: "Dërgo test e-postë",
    administration: "Paneli i administratorit",
    field_1_required: "Fusha 1 është e detyrueshme",
    filed_2_must_be_number: "Fusha 2 duhet të jetë vlerë e numrit të plotë",
    filed_3_is_not_valid_national_id_code: "Fusha 3 NUAQ nuk është valid",
    login_h1: "Ministria e Arsimit dhe Shkencës",
    login_h2: "Sistemi për përparimin e karierës",
    login_signin: "Kyçu",
    login_signup: "Regjistrohu",
    login_signup_link: "Nuk ke llogari të shfrytëzuesit?",
    login_forgot_password: "Ndysho fjalëkalimin",
    login_forgot_password_link: "Fjalëkalimi i harruar",
    login_email: "E-postë",
    login_firstname: "Emri",
    login_lastname: "Mbiemri",
    login_username: "Emri i shfrytëzuesit",
    login_password: "Fjalëkalimi",
    login_confirm_password: "Konfirmo fjalëkalimin",
    login_submit: "Konfirmo",
    login_createuser_success: "Shfrytëzuesi i regjistruar me sukses:",
    required_field: "është fushë e detyrushme",
    wrong_format: "është në format të gabuar",
    password_doesnt_match: "Fjalëkalimet nuk përputhen",
    logout: "Dilni",
    forbidden_h1: "Ndalohet të hyni në këtë faqe.",
    forbidden_h2: "Riorientim në faqen kryesore për",
    formbuilder: "Formë e ndërtuesit",
    configuration: "Konfiguracioni",
    municipality: "Komuna",
    municipalities: "Komuna",
    municipalities_create_new_municipality: "Krijo komunë të re",
    municipalities_municipality_name: "Emri",
    municipalities_municipality_name_en: "Emri anglisht",
    municipalities_municipality_name_al: "Emri shqip",
    municipalities_municipality_code: "Kodi",
    municipalities_municipality_active: "Aktive",
    municipalities_create_success_message: "Komuna është krijuar me sukses",
    municipalities_update_success_message: "Komuna është azhurnuar me sukses",
    municipalities_deleted_success_message: "Komuna është fshirë me sukses",
    municipalities_details: "Detaje për komunën",
    municipalities_delete: "Fshirja e komunës",
    formbuilder_new_form: "Krijo formë të re",
    school: "Shkollë",
    schools: "Shkollë",
    schools_create_new_school: "Krijo shkollë të re",
    schools_school_name: "Emri",
    schools_school_email: "E-postë",
    school_municipality: "Komuna",
    schools_create_success_message: "Shkolla është krijuar me sukses",
    schools_update_success_message: "Shkolla është azhurnuar me sukses",
    schools_deleted_success_message: "Shkolla është fshirë me sukses",
    schools_details: "Detaje për shkollën",
    schools_edit: "Ndrysho të dhënat për shkollën",
    schools_delete: "Fshije shkollën",
    vacancies: "Konkurse",
    new_vacancy_application: "Aplikacion i ri për konkurs",
    vacancy: "Konkurs",
    create_new_vacancy: "Krijo konkurs të ri",
    vacancy_details: "Detaje për konkursin",
    edit_vacancy: "Ndrysho të dhënat për konkursin",
    delete_vacancy: "Fshije konkursin",
    vacancy_create_success_message: "Konkursi është krijuar me sukses",
    vacancy_update_success_message: "Konkursi është azhurnuar me sukses",
    vacancy_deleted_success_message: "Konkursi është fshirë me sukses",
    teacher: "Mësimdhënësi",
    associate: "Bashkëpunëtor profesional",
    commission: "Komisioni",
    advisor: "Këshilltar",
    commission_name: "Emri i komisionit",
    administrator: "Administratori",
    training: "TRAJNIME",
    professional_event:
      "SIMPOZIUME, KONGRESE, KONFERENCA SHKENCORE-PROFESIONALE",
    authorship: "AUTORËSI",
    educational_activity:
      "PJESËMARRJE NË AKTIVITETET PËR PËRMIRËSIMIN E PUNËS EDUKATIVO-ARSIMORE",
    awards_and_recognition: "SHPËRBLIME DHE MIRËNJOHJE",
    professional_title: "Titull shkencor/profesional",
    configuration_area: "Konfiguracioni i fushave",
    training_organizer: "Organizatori i trajnimeve",
    create_new_training_organizer: "Krijo organizator të ri",
    training_organizer_details: "Detaje për organizatorin",
    edit_training_organizer: "Ndrysho organizatorin",
    delete_training_organizer: "Fshije organizatorin",
    training_organizer_create_success_message:
      "Organizatori është krijuar me sukses",
    training_organizer_update_success_message:
      "Organizatori është azhurnuar me sukses",
    training_organizer_deleted_success_message:
      "Organizatori është fshirë me sukses",
    training_role: "Roli i kandidatit",
    create_new_training_role: "Krijo rol të ri",
    training_role_details: "Detaje për rolin",
    edit_training_role: "Ndrysho rolin",
    delete_training_role: "Fshije rolin",
    training_role_create_success_message: "Roli është krijuar me sukses",
    training_role_update_success_message: "Roli është azhurnuar me sukses",
    training_role_deleted_success_message: "Roli është fshirë me sukses",
    training_hour_range: "Kohëzgjatja",
    create_new_training_hour_range: "Krijo rang të ri të orëve",
    training_hour_range_details: "Detaje për rangun e orëve",
    edit_training_hour_range: "Ndrysho rangun e orëve",
    delete_training_hour_range: "Fshije rangun e orëve",
    training_hour_range_create_success_message:
      "Rangu i orëve është krijuar me sukses",
    training_hour_range_update_success_message:
      "Rangu i orëve është azhurnuar me sukses",
    training_hour_range_deleted_success_message:
      "Rangu i orëve është fshirë me sukses",
    event: "Ngjarje",
    create_new_event: "Krijo ngjarje të re",
    event_details: "Detaje për ngjarjen",
    edit_event: "Ndrysho ngjarjen",
    delete_event: "Fshije ngjarjen",
    event_create_success_message: "Ngjarja është krijuar me sukses",
    event_update_success_message: "Ngjarja është azhurnuar me sukses",
    event_deleted_success_message: "Ngjarja është fshirë me sukses",
    authorship_type: "Lloji i autorit",
    create_new_authorship_type: "Krijo lloj të ri",
    authorship_type_details: "Detaje për llojin e autorit",
    authorship_type_edit: "Ndrysho llojin e autorit",
    authorship_type_delete: "Fshije llojin e autorit",
    authorship_type_create_success_message:
      "Me sukses është krijuar lloji i ri i autorit",
    authorship_type_update_success_message: "Me sukses është azhurnuar",
    authorship_type_deleted_success_message: "Me sukses është fshirë",
    educational_activity_type: "Lloji i aktivitetit",
    create_new_educational_activity_type: "Krijo lloj të ri të aktivitetit",
    educational_activity_details: "Detaje për llojin e aktivitetit",
    educational_activity_type_edit: "Ndysho llojin e aktivitetit",
    educational_activity_type_delete: "Fshije llojin e aktivitetit",
    educational_activity_type_create_success_message:
      "Me sukses është krijuar lloji i ri i aktivitetit",
    educational_activity_type_update_success_message:
      "Me sukses është azhurnuar",
    educational_activity_type_deleted_success_message: "Me sukses është fshirë",
    award_recognition: "Bartësi i shpërblimit",
    create_new_award_recognition: "Krijo bartë të ri të shpërblimit",
    award_recognition_details: "Detaje për bartësin e shpërblimit",
    award_recognition_edit: "Ndrysho bartësin e shpërblimit",
    award_recognition_delete: "Fshije bartësin e shpërblimit",
    award_recognition_create_success_message:
      "Me sukses është krijuar bartësi i ri i shpërblimit",
    award_recognition_update_success_message:
      "Me sukses është azhurnuar bartësi",
    award_recognition_deleted_success_message: "Me sukses është fshirë bartësi",
    award_level: "Niveli i shpërblimit",
    create_new_award_level: "Krijo nivel të ri",
    award_level_details: "Detaje për nivelin e ri të shpërblimit",
    award_level_edit: "Ndrysho nivelin e shpërblimit",
    award_level_delete: "Fshije nivelin e shpërblimit",
    award_level_create_success_message:
      "Me sukses është krijuar nivel i ri i shpërblimit",
    award_level_update_success_message: "Me sukses është azhurnuar niveli",
    award_level_deleted_success_message: "Me sukses është fshirë niveli",
    award_type: "Lloji i shpërblimit",
    create_new_award_type: "Krijo lloj të ri të shpërblimit",
    award_type_details: "Detaje për llojin e ri të shpërblimit",
    award_type_edit: "Ndrysho llojin e shpërblimit",
    award_type_delete: "Fshije llojin e shpërblimit",
    award_type_create_success_message:
      "Me sukses është krijuar lloji i ri i shpërblimit",
    award_type_update_success_message: "Me sukses është azhurnuar",
    award_type_deleted_success_message: "Me sukses është fshirë",
    professional_title_type: "Titulli/shkallë shkencore",
    create_new_professional_title_type:
      "Krijo titul të ri / të shkallës shkencore",
    professional_title_type_details: "Detaje për Titullin/shkallë shkencore",
    professional_title_type_edit: "Ndysho Titullin / shkallë shkencore",
    professional_title_type_delete: "Fshije Titullin /shkallë shkencore",
    professional_title_type_create_success_message:
      "Me sukses është krijuar Titulli i ri /shkallë shkencore",
    professional_title_type_update_success_message: "Me sukses është azhurnuar",
    professional_title_type_deleted_success_message: "Me sukses është fshirë",
    professional_title_area: "Fusha",
    create_new_professional_title_area: "Krijo fushë të re",
    professional_title_area_details: "Detaje për fushën",
    professional_title_area_edit: "Ndrysho fushën",
    professional_title_area_delete: "Fshije fushën",
    professional_title_area_create_success_message:
      "Me sukses është krijuar fushë e re",
    professional_title_area_update_success_message: "Me sukses është azhurnuar",
    professional_title_area_deleted_success_message: "Me sukses është fshirë",
    schema_points: "Skema për pikë",
    active: "Aktive",
    points: "Pikët",
    defaultPoints: "Pikët themelore",
    maxPoints: "Pikët maksimale",
    schema_points_update_success_message:
      "Me sukses është azhurnuar skema me pikë",
    invalid_email_address_format: "Forma e email adresës është jovalide",
    phoneNumber: "Numri i telefonit",
    organizer: "Organizatori",
    hourRange: "Kohëzgjatja në orë",
    type: "Lloji",
    place: "Vendi",
    duration: "Kohëzgjatja",
    carrier: "Bartësi",
    awardType: "Lloji i shpërblimit",
    awardLevel: "Niveli i shpërblimit",
    eventType: "Lloji i ngjarjes",
    year: "Viti",
    laborName: "Titulli i punës",
    publicationName: "Titulli i publikimit",
    proof: "Dëshmi",
    title: "Titulli",
    description: "Përshkrimi",
    basic_info: "Të dhëna për bartësin",
    professional_development: "Zhvillim profesional",
    professional_practice: "Praktikë profesionale",
    preview_and_submit: "Rishikimi dhe paraqitja",
    open_vacancies: "Konkurse të hapura",
    my_applications: "Aplikacionet e mia",
    view_applications: "Rishikoni aplikacionet",
    view_applications_for_distribution: "Rishikimi i aplikacioneve për ndarje",
    start_distribution: "Filloni shpërndarjen",
    managing_applications_additional_info:
      "Menaxhimi i aplikacioneve që janë kthyer për rishikim",
    view_graded_applications: "Rishikimi i aplikacioneve të vlerësuara",
    submissionDate: "Data e paraqitjes",
    status: "Statusi",
    open: "Hap",
    startDate: "Data e fillimit",
    endDate: "Data e përfundimit",
    vacancy_evaluation: "Vlerësimi i aplikimit të konkursit",
    grading_schema: "Skema për vlerësim",
    grading_schema_basic_info: "Të dhënat themelore për skekmë",
    grading_schema_config: "Konfiguracioni i skemës",
    grading_schema_create_new: "Krijo skemë të re",
    grading_schema_name: "Emri i skemës",
    grading_schema_locked: "E mbyllur",
    grading_schema_details: "Detaje për skemën e vlerësimit",
    grading_schema_edit: "Ndrysho skemën e vlerësimit",
    grading_schema_delete: "Fshije skemën e vlerësimit",
    grading_schema_create_success_message: "Me sukses është krijuar skemë e re",
    grading_schema_update_success_message: "Me sukses është azhurnuar skema",
    grading_schema_deleted_success_message: "Me sukses është fshirë skema",
    bureau_grading_dashboard: "Vlerësimi i BZHA",
    bureau_grading: "Vlerësimi i BZHA",
    educational_center_grading_dashboard: "Vlerësimi i QAPT",
    educational_center_grading: "Vlerësimi i QAPT",
    school_grading_dashboard: "Vlerësimi i shkollës",
    school_grading: "Vlerësimi i shkollës",
    grade: "Vlerëso",
    all_applications: "Të gjitha aplikimet",
    grading: "Vlerësimi",
    must_be_number: "duhet të jetë numër",
    must_be_positive: "duhet të jetë numër pozitiv",
    required_at_least_one_attachment: "Së paku një dokument duhet të ngjitet",
    action_timestamp: "Koha e veprimit",
    schools_municipality: "Komuna e shkollës",
    no_data_for_analysis: "Nuk ka të dhëna për përpunim",
    application_submited_sucessfully: "Me sukses është parashtruar aplikimi",
    total_points_by_domain: "Gjithsej pikë sipas fushës",
    transfer_item_for_additional_data: "Kthehu në plotësimin",
    expires_in: "Skadon për",
    expires_at: "Skadon më",
    days: "ditët",
    day: "dita",
    application_time_expired: "Koha e aplikimit ka skaduar",
    apply: "Apliko",
    vacancy_released_at: "Konkursi është shpallur më:",
    vanacy_ends_at: "Konkursi mbaron më:",
    list_of_proofs_for_professional_development:
      "Lista e dëshmive për zhvillimin profesional",
    domain: "fusha",
    trainings: "Trajnime",
    professional_events:
      "Simpoziume, kongrese, konferenca shkencore-profesionale",
    educational_activities:
      "Pjesëmarrje në aktivitetet për përmirësimin e punës edukativo-arsimore",
    awards_and_recognitions: "Shpërblime dhe mirënjohje",
    authorships: "Autorësi",
    basic_info_description:
      "Në këtë pjesë të aplikacionit, duhet t'i plotësoni fushat me të dhënat tuaja për të vazhduar në hapin tjetër.",
    choose_type_of_subjects:
      "Zgjidhni llojin e lëndëve tuaja: Të përgjithshme ose profesionale",
    choose_type_of_subjects_description:
      "Nëse ligjëroni në lëndët që janë përgjithshme, në menyjën e mëposhtme zgjidhni opsionin 'Lëndë të përgjithshme'. Nëse ligjëroni në lëndët profesionale, zgjidhni opsionin 'Lëndët profesionale' përkatësisht.",
    training_info_title: "Trajnime",
    training_info_description:
      "Në këtë pjesë të aplikimit, futni trajnimet që kanë marrë pjesë, rolin që e keni pasur në ato trajnime, si dhe kohëzgjatjen e orëve. Në fushën 'dëshmi' duhet të ngjitni një ose më shumë dokumente.",
    professional_event_info_title:
      "Simpoziume, kongrese, konferenca shkencore-profesionale",
    professional_event_info_description:
      "Këtu duhet të futni të dhëna për ngjarjet shkencore-profesionale që  keni marrë pjesë, rolin që e keni pasur në atë ngjarje profesionale si dhe llojin e ngjarjes profesionale. Në fushën 'dëshmi' duhet të ngjitni një ose më shumë dokumente.",
    educational_acvitity_info_title:
      "Pjesëmarrje në aktivitetet për përmirësimin e punës edukativo-arsimore",
    educational_acvitity_info_description:
      "Këtu duhet të futni të dhëna për pjesëmarrjet tuaja në aktivitete për  përmirësimin e punës edukativo-arsimore (Matjet Ndërkombëtare të arritjeve, testimet kombëtare, programet mësimore, projekte inovative, dokumente strategjike, projekte kërkimore, etj.). Në fushën 'dëshmi' duhet të ngjitni një ose më shumë dokumente.",
    awards_and_recognitions_info_title: "Shpërblime dhe mirënjohje",
    awards_and_recognitions_info_description:
      "Në këtë pjesë duhet të futni të dhëna dhe të ngjitni dokumente si dëshmi të shpërblimeve dhe mirënjohjeve që i keni marrë si mësimdhënës ose mentor i nxënësit, si dhe nivelin e garës (Komunale, shtetërore, ndërkombëtar). Në fushën 'dëshmi' duhet të ngjitni një ose më shumë dokumente.",
    authorships_info_title: "Autorësi",
    authorships_info_description:
      "Në këtë pjesë duhet të futni të dhëna dhe të ngjitni dokumente si dëshmi për autorësitë tuaja të teksteve shkollorë, doracakëve, botime në revistë shkencore-profesionale, materialeve dhe punime shkencore-profesionale, gazetë me impakt faktor etj. Në fushën 'dëshmi' duhet të ngjitni një ose më shumë dokumente.",
    num: "Numri rendor",
    training_name: "Emri i trajnimit",
    professional_event_name: "Emri i ngjarjes profesionale",
    professional_event_type: "Llojii ngjarjes profesionale",
    professional_event_role: "Roli",
    professional_event_date: "Data e mbajtjes",
    professional_event_place: "Vendi i mbajtjes",
    no_trainings_added: "Nuk keni trajnime të shtuara",
    add_training: "Shto trajnimin",
    no_professional_event_added: "Nuk keni shtuar ngjarjet profesionale",
    add_professional_event: "Shto ngjarjen profesionale",
    educational_activity_name: "Emri i aktivitetit",
    educational_activity_role: "Roli",
    educational_activity_duration: "Kohëzgjatja",
    educational_activity_year: "Viti i realizimit",
    no_activities_added: "Nuk keni shtuar aktivitete",
    add_activity: "Shto Aktivitet",
    award_name: "Emri i shpërblimit",
    award_carrier: "Bartësi",
    no_awards_or_recognitions_added: "Nuk keni shtuar shpërblimet/mirënjohjet",
    add_awards_or_recognitions: "Shtoni shpërblime/mirënjohje",
    professional_title_info_title: "Titulli/shkencor profesional",
    professional_title_info_description:
      "Këtu duhet të fusni të dhëna dhe të ngjitni dëshmi për titullin shkencor/profesional tuaj.",
    no_professional_titles_added:
      "Nuk keni shtuar titullin shkencor/profesional",
    add_professional_title: "Shto titullin",
    no_authorships_added: "Nuk keni shtuar autorësi",
    add_authorship: "Shto autorësi",
    authorship_title: "Emri i punës",
    authorship_publication_type: "Lloji i publikimit",
    authorship_publication_title: "Emri i publikimit",
    authorship_role: "Roli",
    authorship_release_year: "Viti i botimit",
    date: "Data",
    DRAFT: "Drafti",
    SUBMITTED: "E paraqitur",
    ADDITIONAL_DATA_REQUIRED: "E KTHYER PËR PLOTËSIM",
    COMMISION_EVAL: "EVALUIMI NGA KOMISIONI",
    BRO_CSO_SCHOOL_EVAL: "EVALUIMI NGA BZHA/QAPT/SHKOLLË",
    EVALUATED: "VLERËSUAR",
    REJECTED: "E REFUZUAR",
    PENDING: "PËR PËRPUNIM",
    PROCESSING: "NË PROCES TË PËRPUNIMIT",
    DONE: "E PËRFUNDUAR",
    FAILED: "PA SUKSES",
    CANCELED: "E ANULUAR",
    SUCCESS: "ME SUKSES",
    SUSPENDED: "PROCEDURË E PEZULLUAR",
    dropzoneText: "Tërhiqni datotekën këtu",
    fileType: "Lloji i dokumentit",
    fileName: "Emri i dokumentit",
    fileSize: "Madhësia e dokumentit",
    comment_info_box_text:
      "Nëse keni shënime/koment rreth dëshmive të shfrytëzuesit futeni në fushën më poshtë.",
    additional_data_info_box_title: "Plotësim",
    additional_data_info_box_text:
      "Aplikimi do të kthehet tek shfrytëzuesi i plotësimit, përderisa kenin ndonjë koment për shfrytëzuesin futni në fushën më poshtë",
    apps_for_commission_evaluation: "Aplikime për vlerësim nga komisioni",
    no_apps_for_evaluating: "Nuk ka aplikime për përpunim",
    apps_for_bureau_evaluation: "Aplikime për vlerësim nga BZHA",
    apps_for_educenter_evaluation: "Aplikime për vlerësim nga QAPT",
    apps_for_school_evaluation: "Aplikime për vlerësim nga shkolla",
    educationalCenterGradingStatus: "Statusi",
    submit_evaluation: "Përfundo vlerësimin",
    attach_file: "Ngjit dokumentin",
    no_documents_attached: "Nuk keni ngjit dokumente",
    educenter_grading_info_box_title: "Vlerësimi",
    educenter_grading_info_box_description:
      "Në këtë pjesë duhet të jepni vlerësim nga ana Biros për Zhvillimin e arsimit. Futni pikët dhe ngjitni dokumentin",
    bureau_grading_info_box_title: "Vlerësimi",
    bureau_grading_info_box_description:
      "Në këtë pjesë duhet të jepni vlerësim nga ana Biros për Zhvillimin e arsimit. Futni pikët dhe ngjitni dokumentin",
    school_grading_info_box_title: "Vlerësimi",
    school_grading_info_box_description:
      "Në këtë pjesë duhet të jepni vlerësim nga ana e shkollës. Futni pikët dhe ngjitni dokumentin",
    invalid_data_entry: "Futje jo valide e të dhënave",
    uploadFile: "Ngjit dokumentin",
    evaluation_submited: "Vlerësimi ka përfunduar",
    owned_by: "Lloji i shkollës",
    school_type: "Shkalla e shkollës",
    country_school: "Shtetërore",
    municipality_school: "Komunale",
    elementary_school: "Shkolla Fillore",
    middle_school: "Shkolla e Mesme",
    dateOfBirth: "Data e lindjes",
    commission_eval: "Vlerësimi i komisionit",
    bureau_eval: "Vlerësimi i BZHA",
    eduCenter_eval: "Vlerësimi i QAPT",
    school_eval: "Vlerësimi i shkollës",

    distribution_by_commission: "Shpërndarja sipas komisioneve",
    transfer_applications: "Ndërroni aplikacionet",
    finishing_applications: "Përfundimi i aplikacioneve",

    distribution_applications_by_commission:
      "Shpërndarja e aplikimeve të paraqitura sipas komisioneve",
    transfer_applications_between_commissions:
      "Transferimi i aplikacioneve të dorëzuara ndërmjet komisioneve",
    applications_to_be_finished: "Aplikacionet u kthyen për përpunim",
  },
});

if (window.localStorage.getItem("locale") == null) {
  window.localStorage.setItem("locale", "mk");
  LOCALE.setLanguage(window.localStorage.getItem("locale"));
} else {
  LOCALE.setLanguage(window.localStorage.getItem("locale"));
}

export const changeLanguage = (languageCode) => {
  var lng = window.localStorage.getItem("locale");
  if (typeof languageCode == "string" && (!lng || lng !== languageCode)) {
    window.localStorage.setItem("locale", languageCode);
    window.location.reload();
  }
};
